export default class Accordions {
  constructor() {
    $(".accordion__button").on("click", (e) => {
      const target = $(e.currentTarget || e.target)
      this.toggleAccordion(target)
    })
  }

  toggleAccordion(target) {
    const content = target.next(".accordion__content")

    if (target.hasClass("accordion__button--active")) {
      target.removeClass("accordion__button--active")
      content.stop().slideUp(300)
    } else {
      target.addClass("accordion__button--active")
      content.stop().slideDown(300)
    }
  }
}
